<template>
  <div class="yatebb" role="region" :aria-label="ariaLabel">
    <div class="yatebb__icon-wrap" aria-hidden="true">
      <img
        class="give-badge-warning-icon"
        :src="require('@components/assets/notify-outer.svg')"
        alt="warning icon"
        width="35"
        height="35"
        object-fit="contain"
      />
    </div>
    <div class="yatebb__content">
      <p class="yatebb__title">
        You have {{ expiringBadgeCount }} {{ expiringBadgeCount === 1 ? "badge" : "badges" }} about
        to expire in the next {{ daysUntilExpire }} {{ daysUntilExpire === 1 ? "day" : "days" }}
      </p>
      <button type="button" class="yatebb__action" @click="onActionClick">
        {{ actionLabel }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, defineEmits, defineProps } from "vue";

const props = defineProps({
  expiringBadgeCount: {
    type: Number,
    default: 0,
    validator: (n) => Number.isInteger(n) && n >= 0,
  },
  daysUntilExpire: {
    type: Number,
    default: 7,
    validator: (n) => Number.isInteger(n) && n >= 1,
  },
  actionLabel: {
    type: String,
    default: "Show your expiring badges",
  },
});

const emit = defineEmits(["show-expiring-badges"]);

const ariaLabel = computed(
  () => `Expiring badges: ${props.expiringBadgeCount} in the next ${props.daysUntilExpire} days`
);

function onActionClick() {
  emit("show-expiring-badges");
}
</script>

<style scoped>
.yatebb {
  display: flex;
  align-items: center;
  gap: 16px;
  box-sizing: border-box;
  width: 100%;
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  background: #ffffff;
}

.yatebb__icon-wrap {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 0;
  position: relative;
  top: -12px;
}

.yatebb__icon {
  display: block;
}

.yatebb__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 0;
}

.yatebb__title {
  margin: 0;
  padding: 0;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #344054;
}

.yatebb__action {
  margin: 4px 0 0;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #6941c6;
  text-align: left;
  text-decoration: none;
}

.yatebb__action:focus-visible {
  outline: 2px solid #6941c6;
  outline-offset: 2px;
  border-radius: 2px;
}
</style>
